import { closestTarget } from '../../lib/dom';
import { routeHref } from '../../lib/links';
import { isAnalyticsEnabled, isAnalyticsLoaded, loadAnalytics } from './analytics';
import { readConsent, saveConsent } from './consent';

const BANNER_ID = 'rt-consent';
const BANNER_DELAY_MS = 600;

function showConsentBanner(): void {
  if (!isAnalyticsEnabled() || document.getElementById(BANNER_ID)) return;
  const banner = document.createElement('div');
  banner.id = BANNER_ID;
  banner.className = 'consent';
  banner.setAttribute('role', 'region');
  banner.setAttribute('aria-label', 'Cookie choices');
  banner.innerHTML = `<p><b>Cookies.</b> We'd like to use analytics cookies to understand how our website is used. They're only set if you accept. <a href="${routeHref('/privacy#cookies')}">Privacy Policy</a></p>
    <div class="consent-btns"><button type="button" class="btn btn-ghost btn-sm" data-consent="denied">Decline</button><button type="button" class="btn btn-primary btn-sm" data-consent="granted">Accept analytics</button></div>`;
  document.body.appendChild(banner);
  banner.addEventListener('click', (event) => {
    const button = closestTarget(event, '[data-consent]');
    const decision = button?.dataset.consent;
    if (decision !== 'granted' && decision !== 'denied') return;
    saveConsent(decision);
    banner.remove();
    if (decision === 'granted') loadAnalytics();
    else if (isAnalyticsLoaded()) location.reload(); // withdrawing consent: reload so GA stops
  });
}

export function initAnalytics(): void {
  if (!isAnalyticsEnabled()) return;
  if (navigator.globalPrivacyControl === true && !readConsent()) saveConsent('denied'); // honor Global Privacy Control
  const consent = readConsent();
  if (consent === 'granted') loadAnalytics();
  else if (consent !== 'denied') setTimeout(showConsentBanner, BANNER_DELAY_MS);
  document.addEventListener('click', (event) => {
    if (closestTarget(event, '[data-cookie-settings]')) {
      event.preventDefault();
      showConsentBanner();
    }
  });
}
